















  import {Component, Vue} from 'vue-property-decorator';
  import useFirebaseAuthStore from '@/stores/auth/firebase-auth';

  /**
   * The top-level component that determines currently displayed page depending on the app state.
   */
  @Component({})
  export default class AppRouterView extends Vue {

    private get userSignedIn(): boolean {
      return this.firebaseAuthStore.signedIn;
    }

    private get userNotSignedIn(): boolean {
      return this.firebaseAuthStore.notSignedIn;
    }

    private get userSignInFailed(): boolean {
      return this.firebaseAuthStore.signInFailed;
    }

    private get firebaseAuthStore() {
      return useFirebaseAuthStore();
    }
  }
